import * as React from "react";

import { cn } from "../utils";

export interface SlashProps extends React.SVGProps<SVGSVGElement> {
	decorative?: boolean;
}

export const Slash = React.forwardRef<SVGSVGElement, SlashProps>(
	(
		{
			className,
			decorative = true,
			role,
			"aria-label": ariaLabel,
			...props
		},
		ref,
	) => {
		const accessibilityProps = decorative
			? {
					"aria-hidden": true,
					role: "presentation" as const,
			  }
			: {
					role: role ?? "img",
					"aria-label": ariaLabel ?? "Slash icon",
			  };

		return (
			<svg
				ref={ref}
				viewBox="0 0 16 16"
				width="16"
				height="16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={cn(
					"inline-block shrink-0 text-muted-foreground",
					className,
				)}
				{...accessibilityProps}
				{...props}
			>
				<path
					fill="currentColor"
					fillRule="evenodd"
					clipRule="evenodd"
					d="m4.02 15.4.3-.7 6-14 .29-.68 1.37.59-.3.69-6 14-.29.68z"
				/>
			</svg>
		);
	},
);

Slash.displayName = "Slash";
